import { useEffect } from "react";
import visitApi from "../../api/visitApi";
import { CarouselItem } from "../../common/type";
import { Carousel } from "../../components/Carousel";
import Layout from "../../components/Layout";
import { useGetCarouselHomepage } from "../../hooks/query/useGetCarouselHomepage";
import { useGetTextHomepage } from "../../hooks/query/useGetTextHomepage";
// home page
function Home() {
  const { data: carouselData } = useGetCarouselHomepage();
  const { data: homepage } = useGetTextHomepage();

  const items: CarouselItem[] = Array.isArray(carouselData) ? carouselData : [];
  useEffect(() => {
    const trackVisit = async () => {
      try {
        await visitApi.visit();
      } catch (error) {
        console.error("Track visit error:", error);
      }
    };

    trackVisit();
  }, []);

  return (
    <Layout>
      <section className="w-full">
        <Carousel items={items} />
      </section>
        <section className={`${homepage?.description ? 'block' : 'hidden'} w-full h-[394px] lg:h-fit bg-dark py-[60px] px-[20px] text-center`}>
          <div>
            <p
              className="text-gray-400 text-sm"
              dangerouslySetInnerHTML={{
                __html: homepage?.description || "",
              }}
            />
          </div>
        </section>
    </Layout>
  );
}

export default Home;